var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m9 11.5 2 2L15.5 9m4.5 3c0 4.909-5.354 8.479-7.302 9.615-.221.13-.332.194-.488.228a1.1 1.1 0 0 1-.42 0c-.156-.034-.267-.099-.488-.228C9.354 20.48 4 16.91 4 12V7.218c0-.8 0-1.2.13-1.543a2 2 0 0 1 .548-.79c.276-.242.65-.383 1.398-.663l5.362-2.011c.208-.078.312-.117.419-.132a1 1 0 0 1 .286 0c.107.015.21.054.419.132l5.362 2.01c.748.281 1.123.422 1.398.665a2 2 0 0 1 .547.79c.131.343.131.742.131 1.542z"
  })));
};
export default SvgSecurity;